import { CHAR_CAP, TOKEN_BUDGET, type TokenCount } from '@coderaw/runtime'
import { el } from '../../lib/dom'

export type BudgetBar = {
  readonly element: HTMLElement
  readonly update: (count: TokenCount) => void
}

/** The live "412 / 1024" readout. Red when over budget or over the character cap. */
export const createBudgetBar = (): BudgetBar => {
  const readout = el('span', { class: 'budget-readout' }, `0 / ${TOKEN_BUDGET}`)
  const fill = el('span', { class: 'budget-fill' })
  const track = el('span', { class: 'budget-track', 'aria-hidden': 'true' }, fill)
  const chars = el('span', { class: 'budget-chars' }, `0 chars`)
  const element = el(
    'div',
    { class: 'budget', role: 'status', 'aria-label': 'token budget' },
    el('span', { class: 'budget-label' }, 'tokens'),
    readout,
    track,
    chars,
  )
  const update = (count: TokenCount): void => {
    readout.textContent = `${count.tokens} / ${TOKEN_BUDGET}`
    chars.textContent = `${count.chars.toLocaleString()} / ${CHAR_CAP.toLocaleString()} chars`
    const fraction = Math.min(1, count.tokens / TOKEN_BUDGET)
    fill.style.transform = `scaleX(${fraction})`
    element.classList.toggle('is-over', count.overBudget || count.overCap)
    element.classList.toggle('is-warm', !count.overBudget && fraction > 0.9)
  }
  return { element, update }
}
